import { render, staticRenderFns } from "./allManaged.vue?vue&type=template&id=4c58eb92"
import script from "./allManaged.vue?vue&type=script&lang=ts"
export * from "./allManaged.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports